const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Get the full image URL for a product image path
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  
  // If it's already a full URL (http/https), return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // Otherwise, prepend the backend URL
  return `${BACKEND_URL}${imagePath}`;
};

/**
 * Tiny (~1KB) blurred placeholder — paints instantly on slow networks
 */
export const getBlurUrl = (imagePath) => {
  if (!imagePath) return null;
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) return null;
  if (imagePath.startsWith('/api/images/') && !imagePath.includes('/thumb/') && !imagePath.includes('/blur/')) {
    const filename = imagePath.replace('/api/images/', '');
    return `${BACKEND_URL}/api/images/blur/${filename}`;
  }
  return null;
};

/**
 * Mid-size variant (w=480|800) — much lighter than the full 1200px original
 */
export const getSizedUrl = (imagePath, w = 800) => {
  if (!imagePath) return null;
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) return imagePath;
  if (imagePath.startsWith('/api/images/') && !imagePath.includes('/thumb/') && !imagePath.includes('/blur/')) {
    return `${BACKEND_URL}${imagePath}?w=${w}`;
  }
  return `${BACKEND_URL}${imagePath}`;
};
export const getThumbUrl = (imagePath) => {
  if (!imagePath) return null;
  
  // If it's already a full URL (external), return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // Convert /api/images/filename.jpg -> /api/images/thumb/filename.jpg
  if (imagePath.startsWith('/api/images/') && !imagePath.includes('/thumb/')) {
    const filename = imagePath.replace('/api/images/', '');
    return `${BACKEND_URL}/api/images/thumb/${filename}`;
  }
  
  return `${BACKEND_URL}${imagePath}`;
};
